import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "../Hooks/useAuth";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const Navigate = useNavigate();
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();

    const result = login({ id, pw });
    if (result) {
      Navigate("/Admin/Dashboard");
    } else {
      setPw("");
      return;
    }
  };

  return (
    <Wrapper>
      <Card>
        <div style={{ textAlign: "center", paddingLeft: "20px" }}>
          <img
            style={{ textAlign: "center" }}
            width={"150px"}
            src={"/logo192.png"}
            alt="logo"
          ></img>
        </div>
        <Title>DHKSOLUTION CORPORATION</Title>
        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder="ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <Input
            type="password"
            placeholder="Password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
          />
          <Button type="submit">Sign In</Button>
        </form>
      </Card>
    </Wrapper>
  );
};

// Styled Components
const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
`;

const Card = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  width: 100%;
  max-width: 400px;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 2rem;
  text-align: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  &:focus {
    outline: 2px solid #3b82f6;
    border-color: transparent;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 0.8rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: #1d4ed8;
  }
`;

export default LoginPage;
